import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderTop = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="row top-block align-items-center">
        <div className="col text-center">
          <div
            aria-label="welcome text"
            className="welcome-container"
            data-qa="welcome"
          >
            Hello There!
          </div>
        </div>
      </div>
      <style jsx>{`
        .top-block {
          padding-top: 10px;
        }
        .welcome-container {
          text-align: center;
          color: ${theme.colors.primary};
          font-size: 12px;
          text-transform: capitalize;
        }
        .advertise-link-container {
          text-align: center;
          font-size: 12px;
        }
        .advertise-link-container > a {
          text-decoration: none;
          color: ${theme.colors.breadcrumbhover};
        }
      `}</style>
    </>
  );
};

export default HeaderTop;
